export default __webpack_public_path__ + "static/media/rotateLeft.67797825.svg";